import React from 'react';
import { Link } from 'react-router-dom';
import classes from './DesktopNavBar.module.css';
import NavData from '../../data/Navigation';

const DesktopNavBar = props => {
    return (
        <nav className={classes.navBar}>
            <ul>
                {NavData.map((navItem) => (
                    <Link
                        key={navItem.title}
                        to={navItem.path}
                        className={classes.link}
                    >
                        <li>
                            {/* <span className={classes.navTitle}>{navItem.title}</span> */}
                            <span className={classes.icon}>{navItem.icon}</span>
                        </li>
                    </Link>
                ))}
            </ul>
        </nav>
    )
}

export default DesktopNavBar;
